import { axiosRequest } from "@/lib/axios";
import type { MembershipRequest, MembershipResponse, UserRole } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const membershipApi = {
	index: (workspaceId: string) => {
		return axiosRequest<MembershipResponse[]>({ url: `${API_BASE_URL}/${workspaceId}/memberships`, method: "GET" });
	},

	create: (workspaceId: string, payload: MembershipRequest) => {
		return axiosRequest<MembershipResponse>({ url: `${API_BASE_URL}/${workspaceId}/memberships`, method: "POST", data: payload });
	},

	updateRole: (id: string, workspaceId: string, role: UserRole) => {
		return axiosRequest<MembershipResponse>({ url: `${API_BASE_URL}/${workspaceId}/memberships/${id}`, method: "PATCH", data: { role: role } });
	},

	delete: (id: string, workspaceId: string) => {
		return axiosRequest<void>({ url: `${API_BASE_URL}/${workspaceId}/memberships/${id}`, method: "DELETE" });
	},

	resendInvitation: (id: string, workspaceId: string) => {
		return axiosRequest<MembershipResponse>({ url: `${API_BASE_URL}/${workspaceId}/memberships/${id}/resend`, method: "PATCH" });
	},
};
